import { Reveal, Eyebrow } from "@/components/Reveal";
import { Seal } from "@/components/Seal";
import { scrollToId } from "@/App";

const STREET_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_sanzone-launch/artifacts/74mz2s97_image.png";
const COUTURE_IMG =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_sanzone-launch/artifacts/sel615mg_image.png";

const lines = [
  {
    index: "01",
    name: "Street Apparel",
    img: STREET_IMG,
    alt: "SANZONE one-of-one custom sneakers in textured gold with red laces, presented as wearable art",
    spec: "Wearable art — 1 of 1 — Studio made",
    copy: "Hoodies, crewnecks, tees, skull caps and future drops — shown here as planned direction, not guaranteed inventory.",
    tags: ["Hoodies", "Crewnecks", "Tees", "Skull Caps", "Future Drops"],
    cta: "Join the Waitlist",
    target: "#waitlist",
    testid: "street-line-cta",
    span: "lg:col-span-7",
    offset: "",
  },
  {
    index: "02",
    name: "Couture",
    img: COUTURE_IMG,
    alt: "The Kourier Kore Jacket by SANZONE — a hand-painted one-of-one blazer with a wolf graphic on the back",
    spec: "Hand-painted — 1 of 1 — By application",
    copy: "Custom, one-of-one design inquiries. Every piece begins with a conversation, never a catalog.",
    tags: ["One-of-One", "Custom Design", "By Application"],
    cta: "Apply for a Custom Piece",
    target: "#apply",
    testid: "couture-line-cta",
    span: "lg:col-span-5",
    offset: "lg:mt-24",
  },
];

export default function LinePreviews() {
  return (
    <section className="relative border-t border-[#221812]/10 bg-[#ECE5D6] px-6 py-28 sm:px-12 sm:py-36 lg:px-20" data-testid="line-previews-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex items-end justify-between gap-8">
          <Reveal>
            <Eyebrow>[ 02 — Two Lines ]</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-code hidden text-[10px] uppercase tracking-[0.35em] text-[#8C857B] sm:block">
              Street / Couture
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 lg:grid-cols-12 lg:gap-12">
          {lines.map((line, i) => (
            <Reveal key={line.index} delay={0.1 + i * 0.15} className={`${line.span} ${line.offset}`}>
              <article
                className="group relative flex h-full flex-col border border-[#221812]/15 bg-[#F9F5EB] transition-colors duration-500 hover:border-[#9A7B3F]/70"
                data-testid={`line-card-${line.index}`}
              >
                <Seal className="absolute -top-4 right-8 z-10" />
                <div className="relative m-3 overflow-hidden sm:m-4">
                  <img
                    src={line.img}
                    alt={line.alt}
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  />
                  <p className="font-code absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-[#F4EEE3]/90 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    {line.spec}
                  </p>
                </div>
                <div className="flex flex-1 flex-col px-8 pb-10 pt-2 sm:px-12 sm:pb-12">
                  <p className="font-code text-[10px] uppercase tracking-[0.35em] text-[#9A7B3F]">
                    [ {line.index} // {line.name} ]
                  </p>
                  <h3 className="mt-5 font-display text-3xl tracking-tight text-[#221812] sm:text-4xl">{line.name}</h3>
                  <p className="mt-5 text-sm leading-relaxed text-[#55504A] sm:text-base">{line.copy}</p>
                  <div className="mt-7 flex flex-wrap gap-2">
                    {line.tags.map((tag) => (
                      <span
                        key={tag}
                        className="font-code border border-[#221812]/20 px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-[#55504A]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <button
                    onClick={() => scrollToId(line.target)}
                    className="mt-9 self-start text-xs uppercase tracking-[0.3em] text-[#5E1A22] underline decoration-[#5E1A22]/40 underline-offset-8 transition-colors duration-300 hover:text-[#221812]"
                    data-testid={line.testid}
                  >
                    {line.cta}
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
